import { render, staticRenderFns } from "./EditionActionPanel.vue?vue&type=template&id=6484aa12&scoped=true"
import script from "./EditionActionPanel.vue?vue&type=script&lang=js"
export * from "./EditionActionPanel.vue?vue&type=script&lang=js"
import style0 from "./EditionActionPanel.vue?vue&type=style&index=0&id=6484aa12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6484aa12",
  null
  
)

export default component.exports